export default "__VITE_ASSET__65f8ea29__"